// This file was generated by https://github.com/redbubble/design/blob/master/scripts/generateIcons.js
import React from 'react';
import Icon from '../Icon';

const UploadIcon = props => <Icon {...props} dangerouslySetIcon={'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M11.984 3.986a1 1 0 00-.193.024 1 1 0 00-.098.025 1 1 0 00-.052.018 1 1 0 00-.041.015 1 1 0 00-.002.002 1 1 0 00-.088.043 1 1 0 00-.002.002 1 1 0 00-.328.291L7.293 8.293a1 1 0 101.414 1.414L11 7.414V15a1 1 0 102 0V7.414l2.293 2.293a1 1 0 101.414-1.414L12.824 4.41a1 1 0 00-.41-.334 1 1 0 00-.137-.05 1 1 0 00-.293-.04zm-9 10A1 1 0 002 15v4a1 1 0 001 1h18a1 1 0 001-1v-4a1 1 0 10-2 0v3H4v-3a1 1 0 00-1.016-1.014z" fill="currentColor"/></svg>'} />;

UploadIcon.displayName = 'UploadIcon';

export default UploadIcon;
